import React from 'react';
import style from './Body.module.css';

const Body = ({children}: any) => {
  return (
    <div className={style.landingPage}>
      <div className={style.content}>
        {children}
      </div>
    </div>
  )
}

export default React.memo(Body);
